export enum PageLifecycle {
  Hidden = "hidden",
  Active = "active",
  Passive = "passive",
  Frozen = "frozen",
  Discarded = "discarded",
  Terminated = "terminated",
}
